import { render } from "./Unbounded.vue?vue&type=template&id=64f3665e"
import script from "./Unbounded.vue?vue&type=script&lang=js"
export * from "./Unbounded.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/251623126/emo-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__